import React from 'react';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import { TopContentWrapper } from '../shared.styles';

const ProductChartActions = ({ handleSelectAll, handleUnselectAll }) => (
	<TopContentWrapper>
		<ActionButton
			defaultText='Select all'
			color={Colors.darkBlue}
			onClick={handleSelectAll}
		/>
		<ActionButton
			defaultText='Unselect all'
			color={Colors.darkBlue}
			onClick={handleUnselectAll}
		/>
	</TopContentWrapper>
);

export default ProductChartActions;
